export default __webpack_public_path__ + "static/media/016-soda.81a8e7c1.svg";